// pages/AboutUsPage.tsx
import React from 'react';
import Section from '../components/layout/Section';
import img from '../assets/team.png';

const AboutUsPage: React.FC = () => {
  return (
    <div className="pt-20">
      <Section title="Meet Lemay Roofing">
        <div className="max-w-3xl mx-auto text-gray-700 space-y-6 text-lg">
          <div
            className="bg-cover bg-center py-24 md:py-40 text-white relative"
            style={{ backgroundImage: `url(${img})` }}
          />
          {/*<img*/}
          {/*  src="https://placehold.co/600x400/64748B/e2e8f0?text=Lemay+Roofing+Team"*/}
          {/*  alt="Lemay Roofing Owner or Team"*/}
          {/*  className="rounded-lg shadow-xl mx-auto mb-8 w-full max-w-md"*/}
          {/*  onError={(e) => (e.currentTarget.src = 'https://placehold.co/600x400/cccccc/333333?text=Image+Not+Found')}*/}
          {/*/>*/}
          <p>
            Lemay Roofing isn't just another roofing company; we are a cornerstone of the Avon Park community,
            built on a foundation of experience, integrity, and a commitment to excellence. For over <strong>30 years</strong>,
            our owner has been at the forefront of the residential roofing industry, bringing unparalleled expertise and a
            passion for quality to every project we undertake.
          </p>
          <h3 className="text-2xl font-semibold text-slate-800 pt-4">Our Story</h3>
          <p>
            Founded with the vision of providing reliable and high-quality roofing services to homeowners
            in Avon Park and beyond, Lemay Roofing has grown through word-of-mouth referrals and a
            steadfast dedication to our craft. Our owner's journey in the roofing industry began over three
            decades ago, and that wealth of knowledge is infused into every aspect of our operations – from the
            initial consultation to the final inspection.
          </p>
          <h3 className="text-2xl font-semibold text-slate-800 pt-4">Our Mission</h3>
          <p>
            Our mission is simple: to provide our customers with durable, dependable roofing solutions that
            protect their most valuable assets. We strive to achieve this through:
          </p>
          <ul className="list-disc list-inside space-y-2 pl-4">
            <li>Superior Workmanship: Employing skilled, trained, and respectful roofing professionals.</li>
            <li>Premium Materials: Sourcing the best roofing materials to ensure longevity and performance.</li>
            <li>Honest Communication: Keeping you informed every step of the way.</li>
            <li>Fair Pricing: Offering competitive and transparent estimates.</li>
            <li>Unwavering Commitment: Ensuring every customer is completely satisfied with our work.</li>
          </ul>
          <h3 className="text-2xl font-semibold text-slate-800 pt-4">Why Experience Matters</h3>
          <p>
            With over 30 years in the field, we understand the unique challenges and weather conditions that
            roofs in Florida face. This experience allows us to recommend the best materials and installation
            techniques to withstand the Florida sun, heavy rains, and hurricane season. We don't just build
            roofs; we build relationships based on trust and the quality of our work.
          </p>
        </div>
      </Section>
    </div>
  );
};

export default AboutUsPage;
